/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewPopularityRankingResult } from './CRSFSecReviewPopularityRankingResult';
import {
    CRSFSecReviewPopularityRankingResultFromJSON,
    CRSFSecReviewPopularityRankingResultFromJSONTyped,
    CRSFSecReviewPopularityRankingResultToJSON,
} from './CRSFSecReviewPopularityRankingResult';
import type { CRSFSecReviewPrivacyInfoResult } from './CRSFSecReviewPrivacyInfoResult';
import {
    CRSFSecReviewPrivacyInfoResultFromJSON,
    CRSFSecReviewPrivacyInfoResultFromJSONTyped,
    CRSFSecReviewPrivacyInfoResultToJSON,
} from './CRSFSecReviewPrivacyInfoResult';
import type { CRSFSecReviewPrivacyPolicyAnalysisExternalResult } from './CRSFSecReviewPrivacyPolicyAnalysisExternalResult';
import {
    CRSFSecReviewPrivacyPolicyAnalysisExternalResultFromJSON,
    CRSFSecReviewPrivacyPolicyAnalysisExternalResultFromJSONTyped,
    CRSFSecReviewPrivacyPolicyAnalysisExternalResultToJSON,
} from './CRSFSecReviewPrivacyPolicyAnalysisExternalResult';
import type { CRSFSecReviewPrivacySpecificTrackingTechEnum } from './CRSFSecReviewPrivacySpecificTrackingTechEnum';
import {
    CRSFSecReviewPrivacySpecificTrackingTechEnumFromJSON,
    CRSFSecReviewPrivacySpecificTrackingTechEnumFromJSONTyped,
    CRSFSecReviewPrivacySpecificTrackingTechEnumToJSON,
} from './CRSFSecReviewPrivacySpecificTrackingTechEnum';
import type { CRSFSecReviewPrivacyStatusEnum } from './CRSFSecReviewPrivacyStatusEnum';
import {
    CRSFSecReviewPrivacyStatusEnumFromJSON,
    CRSFSecReviewPrivacyStatusEnumFromJSONTyped,
    CRSFSecReviewPrivacyStatusEnumToJSON,
} from './CRSFSecReviewPrivacyStatusEnum';
import type { CRSFSecReviewPrivacyTechnologiesResult } from './CRSFSecReviewPrivacyTechnologiesResult';
import {
    CRSFSecReviewPrivacyTechnologiesResultFromJSON,
    CRSFSecReviewPrivacyTechnologiesResultFromJSONTyped,
    CRSFSecReviewPrivacyTechnologiesResultToJSON,
} from './CRSFSecReviewPrivacyTechnologiesResult';

/**
 * 
 * @export
 * @interface CRSFSecReviewPrivacyData
 */
export interface CRSFSecReviewPrivacyData {
    /**
     * 
     * @type {CRSFSecReviewPopularityRankingResult}
     * @memberof CRSFSecReviewPrivacyData
     */
    popularity_ranking?: CRSFSecReviewPopularityRankingResult;
    /**
     * 
     * @type {CRSFSecReviewPrivacyInfoResult}
     * @memberof CRSFSecReviewPrivacyData
     */
    privacy_info?: CRSFSecReviewPrivacyInfoResult;
    /**
     * 
     * @type {CRSFSecReviewPrivacyPolicyAnalysisExternalResult}
     * @memberof CRSFSecReviewPrivacyData
     */
    privacy_policy_analysis?: CRSFSecReviewPrivacyPolicyAnalysisExternalResult;
    /**
     * 
     * @type {CRSFSecReviewPrivacyStatusEnum}
     * @memberof CRSFSecReviewPrivacyData
     */
    status?: CRSFSecReviewPrivacyStatusEnum;
    /**
     * 
     * @type {CRSFSecReviewPrivacyTechnologiesResult}
     * @memberof CRSFSecReviewPrivacyData
     */
    technologies_found?: CRSFSecReviewPrivacyTechnologiesResult;
    /**
     * 
     * @type {Array<CRSFSecReviewPrivacySpecificTrackingTechEnum>}
     * @memberof CRSFSecReviewPrivacyData
     */
    undeclared_tracking_technology?: Array<CRSFSecReviewPrivacySpecificTrackingTechEnum>;
}

/**
 * Check if a given object implements the CRSFSecReviewPrivacyData interface.
 */
export function instanceOfCRSFSecReviewPrivacyData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSecReviewPrivacyDataFromJSON(json: any): CRSFSecReviewPrivacyData {
    return CRSFSecReviewPrivacyDataFromJSONTyped(json, false);
}

export function CRSFSecReviewPrivacyDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewPrivacyData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'popularity_ranking': !exists(json, 'popularity_ranking') ? undefined : CRSFSecReviewPopularityRankingResultFromJSON(json['popularity_ranking']),
        'privacy_info': !exists(json, 'privacy_info') ? undefined : CRSFSecReviewPrivacyInfoResultFromJSON(json['privacy_info']),
        'privacy_policy_analysis': !exists(json, 'privacy_policy_analysis') ? undefined : CRSFSecReviewPrivacyPolicyAnalysisExternalResultFromJSON(json['privacy_policy_analysis']),
        'status': !exists(json, 'status') ? undefined : CRSFSecReviewPrivacyStatusEnumFromJSON(json['status']),
        'technologies_found': !exists(json, 'technologies_found') ? undefined : CRSFSecReviewPrivacyTechnologiesResultFromJSON(json['technologies_found']),
        'undeclared_tracking_technology': !exists(json, 'undeclared_tracking_technology') ? undefined : ((json['undeclared_tracking_technology'] as Array<any>).map(CRSFSecReviewPrivacySpecificTrackingTechEnumFromJSON)),
    };
}

export function CRSFSecReviewPrivacyDataToJSON(value?: CRSFSecReviewPrivacyData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'popularity_ranking': CRSFSecReviewPopularityRankingResultToJSON(value.popularity_ranking),
        'privacy_info': CRSFSecReviewPrivacyInfoResultToJSON(value.privacy_info),
        'privacy_policy_analysis': CRSFSecReviewPrivacyPolicyAnalysisExternalResultToJSON(value.privacy_policy_analysis),
        'status': CRSFSecReviewPrivacyStatusEnumToJSON(value.status),
        'technologies_found': CRSFSecReviewPrivacyTechnologiesResultToJSON(value.technologies_found),
        'undeclared_tracking_technology': value.undeclared_tracking_technology === undefined ? undefined : ((value.undeclared_tracking_technology as Array<any>).map(CRSFSecReviewPrivacySpecificTrackingTechEnumToJSON)),
    };
}

